export default "__VITE_ASSET__DXn2_6NR__"